import React, { useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import Routes from '../Routes';
import { mapState, initialize } from '../../slices/appSlice';
import * as S from './styled';

function AppContainer() {
  const { initializeInProcess, profile } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initialize());
  }, []);

  if (initializeInProcess) {
    return <div>Initialize in process...</div>;
  }

  return (
    <ErrorBoundary>
      <S.App>
        <BrowserRouter>
          <Routes role={profile?.role} />
        </BrowserRouter>
      </S.App>
    </ErrorBoundary>
  );
}

export default AppContainer;
